export default {
  uncategorizedFiles: {
    title: "All Uncategorized Files",
    subtitle: "",
    value: ""
  },
  returnFiles: {
    title: "Return Files",
    subtitle: "",
    value: "_return_files"
  },

  // Scans
  photogrammetryImplantPositionExport: {
    title: "Implant Position Export",
    subtitle: "Photogrammetry",
    fileType: "scan",
    value: "photogrammetry_implant_position_export",
    intraoral: true,
    multiple: false,
    photogrammetry_only: true,
    immediate_only: false
  },
  existingProsthesisInSituScan: {
    title: "Existing Prosthesis",
    subtitle: "In-Situ Scan",
    fileType: "scan",
    value: "existing_prosthesis_in_situ_scan",
    intraoral: true,
    multiple: false,
    photogrammetry_only: false,
    immediate_only: false
  },
  tissueOfRestoringArchUsingNarrowScanBodies: {
    title: "Tissue of Restoring Arch",
    subtitle: "Using Narrow Scan Bodies",
    fileType: "scan",
    value: "tissue_of_restoring_arch_using_narrow_scan_bodies",
    intraoral: true,
    multiple: false,
    photogrammetry_only: false,
    immediate_only: false
  },
  existingProsthesisExtraOrally360UsingScanAnalogs: {
    title: "Existing Prosthesis Extra-Orally 360",
    subtitle: "Using Scan Analogs",
    fileType: "scan",
    value: "existing_prosthesis_extra_orally_360_using_scan_analogs",
    intraoral: true,
    multiple: false,
    photogrammetry_only: false,
    immediate_only: false
  },
  antagonistDentition: {
    title: "Antagonist Dentition",
    subtitle: "",
    fileType: "scan",
    value: "antagonist_dentition",
    intraoral: true,
    multiple: false,
    photogrammetry_only: false,
    immediate_only: false
  },
  biteScan: {
    title: "Bite Scan",
    subtitle: "",
    fileType: "scan",
    value: "bite_scan",
    intraoral: true,
    multiple: true,
    photogrammetry_only: false,
    immediate_only: false
  },
  toothDesign: {
    title: "Tooth Design",
    subtitle: null,
    fileType: "scan",
    value: "tooth_design",
    intraoral: true,
    multiple: false,
    photogrammetry_only: false,
    immediate_only: false
  },
  upperDentition: {
    title: "Upper Dentition",
    subtitle: "",
    fileType: "scan",
    value: "upper_dentition",
    intraoral: true,
    multiple: false,
    photogrammetry_only: false,
    immediate_only: true
  },
  lowerDentition: {
    title: "Lower Dentition",
    subtitle: "",
    fileType: "scan",
    value: "lower_dentition",
    intraoral: true,
    multiple: false,
    photogrammetry_only: false,
    immediate_only: true
  },
  midGaugeScan: {
    title: "Mid Gauge Scan",
    subtitle: "",
    fileType: "scan",
    value: "mid_gauge_scan",
    intraoral: true,
    multiple: false,
    photogrammetry_only: false,
    immediate_only: true
  },
  sstDenture360: {
    title: "SST Denture 360",
    subtitle: "",
    fileType: "scan",
    value: "sst_denture_360",
    intraoral: true,
    multiple: false,
    photogrammetry_only: false,
    immediate_only: true
  },
  tissueOfRestoringArch: {
    title: "Tissue of Restoring Arch",
    subtitle: "",
    fileType: "scan",
    value: "tissue_of_restoring_arch",
    intraoral: true,
    multiple: false,
    photogrammetry_only: false,
    immediate_only: true
  },

  // Photos
  fullFaceSmilingWithRelaxedBite: {
    title: "Full-Face Smiling",
    subtitle: "With Relaxed Bite",
    fileType: "photo",
    value: "full_face_smiling_with_relaxed_bite",
    multiple: false,
    photogrammetry_only: false,
    immediate_only: false
  },
  fullFaceSmilingWithRelaxedBiteUsingRetractors: {
    title: "Full-Face Smiling",
    subtitle: "With Relaxed Bite using Retractors",
    fileType: "photo",
    value: "full_face_smiling_with_relaxed_bite_using_retractors",
    multiple: false,
    photogrammetry_only: false,
    immediate_only: false
  },

  // Other
  constructionFile: {
    title: "Construction File",
    subtitle: "Mandatory with provided Tooth Design",
    fileType: "other",
    value: "construction_file",
    intraoral: false,
    multiple: true,
    photogrammetry_only: false,
    immediate_only: false
  }
}
